













import { Component, Vue } from 'vue-property-decorator';
import Popup from '@/components/popups/Popup.vue';
import { namespace } from 'vuex-class';
import { dateToYYYYMMDD, getMonthName } from '@/utils/date-helpers';

const ui = namespace('UI');

const puzzle = namespace('Puzzle');

@Component({
  components: {
    Popup,
  },
})
export default class ChangeDatePopup extends Vue {
  @puzzle.Action
  private changePuzzleByDate!: (date: string) => void;

  @ui.Mutation
  private closePopup!: () => void;

  @puzzle.State
  private tempDate!: Date;

  @puzzle.Mutation
  private clearPuzzle!: () => void;

  private change() {
    this.changePuzzleByDate(dateToYYYYMMDD(this.tempDate));
    this.closePopup();
  }

  private cancel() {
    this.closePopup();
  }

  @puzzle.State
  private date!: string;

  get formattedDate() {
    const date = new Date(this.tempDate);
    return `${getMonthName(date.getMonth())} ${date.getDate()}, ${date.getFullYear()}`;
  }

  private changeDate: string = (window as any).languages['ChangeDate'];
  private yes: string = (window as any).languages['Yes'];
  private no: string = (window as any).languages['No'];
}
